export default __webpack_public_path__ + "static/media/Sabrina_9781408309124.728d023e.jpg";